import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    sideNavigatorOpened: false,
    rolePermissions: false,
    currentReport: '',
    currentSupplier: {},

    /** @type {String} */
    supplierInternalId: null,
  }, //state

  getters: {
    getSideNavigatorOpened: state => {
      return state.sideNavigatorOpened;
    },
    getCurrentSupplier: state => {
      return state.currentSupplier;
    },
    getCurrentReport: state => {
      return state.currentReport;
    },
    getSupplierInternalId: (state) => state.supplierInternalId,
  }, // getters

  mutations: {
    setSideNavigatorOpened(state, value) {
      state.sideNavigatorOpened = value;
    },
    setCurrentReport(state, value) {
      state.currentReport = value;
    },
    setIsUserAuthorized(state, value) {
      state.rolePermissions = value;
    },
    setCurrentSupplier(state, value) {
      state.currentSupplier = value;
    },
    setSupplierInternalId: (state, value) => state.supplierInternalId = value,
  }, // mutations
})
